import React, { useState } from 'react'
import './Selling.css'
import carImage from '../../assets/sellcar1.png'
import ReactApexChart from 'react-apexcharts'
import { sellBottom, sellBottom2, sellCars } from '../../utilits/statisticTools'
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { offerbottom, offers } from '../../utilits/sellOffer'
import { icons } from '../../utilits/icons'

export default function Selling() {

  const [car, setCar] = useState('');
  const [condition, setCondition] = useState('');

  const handleChange = (event) => {
    setCar(event.target.value);
  };

  const handleChangeCon = (event) => {
    setCondition(event.target.value);
  };


  return (
    <div className='sell'>
      <div className="sell-container">
        <h1 className='sell-title'>Seeling Cars</h1>
        <div className="sell-top">
          <div className="sell-left">
            <h3>2022 Audi</h3>
            <img src={carImage} alt="" />
          </div>
          <div className="sell-right">
            <h3>Tracking History</h3>
            <ReactApexChart options={sellCars.options} series={sellCars.series} type="bar" height={350} />
          </div>
        </div>

        <div className="sell-bottom">
          <div className="sell-bottom_top">
            <h3>Offers</h3>
            <div className="selects">
              <div className="select-one">
              <Box sx={{ minWidth: 120}}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Condition</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={condition}
                    label="Condition"
                    onChange={handleChangeCon}
                  >
                    <MenuItem value={'new'}>New</MenuItem>
                    <MenuItem value={'old'}>Old</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              </div>

              <div className="select-two">
                <Box sx={{ minWidth: 120}}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Cars</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={car}
                      label="Cars"
                      onChange={handleChange}
                    >
                      <MenuItem value={'audi'}>Audi</MenuItem>
                      <MenuItem value={'toyota'}>Toyota</MenuItem>
                      <MenuItem value={'bmw'}>BMW</MenuItem>
                      <MenuItem value={'porsche'}>Porsche</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </div>
          </div>

          <div className="sell-bottom-section">
              {
                offers.map((element, value)=>{
                  return <div className='offer-section'>
                    <div className="offer-section_left">
                      <h4>{element.name}</h4>
                      <p>${element.price} <span>avarage price</span></p>
                      <h5>market avarage is <span>${element.price}</span></h5>
                      <div>{icons.sellBottom}</div>
                    </div>
                    <div className="offer-section_center">
                      <div className="offer-section_center-one">
                        <ReactApexChart options={sellBottom.options} series={sellBottom.series} type="radialBar" />
                      </div>
                      <div className="offer-section_center-two">
                        <ReactApexChart options={sellBottom2.options} series={sellBottom2.series} type="radialBar" height={250}/>
                      </div>
                    </div>
                    <div className="offer-section_right">
                      <div className="offer-section_one">
                        <span>{icons.sellBottomCar}</span>
                        <h4>$1,174</h4>
                        <p>Model Spend</p>
                      </div>
                      <div className="offer-section_two">
                        <span>{icons.sellBottomRepeat}</span>
                        <h4>$1,174</h4>
                        <p>Model Spend</p>
                      </div>
                      <div className="offer-section_three">
                        <span>{icons.sellBottomDol}</span>
                        <h4>$1,174</h4>
                        <p>Model Spend</p>
                      </div>
                    </div>
                  </div>
                })
              }
          </div>
        </div>
      </div>
    </div>
  )
}
